module.exports = __webpack_public_path__ + "img/7eleven.982e22aa.png";